import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { useAuthStore } from '@/store/auth'
import axios from 'axios'
import { globals } from './utils/globals'

const app = createApp(App)

fetch('/config.json')
  .then(res => res.json())
  .then(config => {
    // 把外部配置写入全局
    globals.$config = config
    // console.log('使用服务器配置:', globals.$config.serverUrl)
    // 然后再挂载应用
    createApp(App).mount('#app')
  })
  .catch(err => {
    // console.error('加载配置失败:', err)
    // 如果 config.json 加载失败，兜底用本地默认配置
    globals.$config = { serverUrl: 'http://localhost:8080' }
    createApp(App).mount('#app')
  })
  .finally(() => {
    // 无论配置加载成功与否，都继续应用初始化
    app.use(createPinia())
    app.use(router)
    app.use(ElementPlus)
    app.mount('#app')

    document.title="正科电机后台管理"

    // 初始化认证状态
    const authStore = useAuthStore()
    authStore.init()
  })